// // client/src/components/ai/AIGenerator.jsx
// import React, { useState } from 'react';
// import { motion } from 'framer-motion';
// import { Sparkles, Loader2, Wand2, Copy, Check, Plus } from 'lucide-react';
// import toast from 'react-hot-toast';
// import aiAPI from '../../api/aiAPI';

// const AIGenerator = ({ onGenerated, onClose, existingFormData, setFormData }) => {
//   const [loading, setLoading] = useState(false);
//   const [generated, setGenerated] = useState(null);
//   const [copied, setCopied] = useState(false);
//   const [formData, setLocalFormData] = useState({
//     title: existingFormData?.title || '',
//     theme: '',
//     genre: existingFormData?.genre || 'ghazal',
//     language: 'urdu',
//     style: 'classical'
//   });
  
//   const genres = [
//     { value: 'ghazal', label: 'Ghazal', icon: '💕' },
//     { value: 'nazm', label: 'Nazm', icon: '📜' },
//     { value: 'sher', label: 'Sher', icon: '✨' },
//     { value: 'rubai', label: 'Rubai', icon: '🕌' }
//   ];
  
//   const languages = [
//     { value: 'urdu', label: 'Urdu', script: 'اردو' },
//     { value: 'hindi', label: 'Hindi', script: 'हिन्दी' },
//     { value: 'english', label: 'English', script: 'English' }
//   ];
  
//   const styles = [
//     { value: 'classical', label: 'Classical', description: 'Traditional classical style' },
//     { value: 'modern', label: 'Modern', description: 'Contemporary modern style' },
//     { value: 'romantic', label: 'Romantic', description: 'Love and romance focused' },
//     { value: 'sufi', label: 'Sufi', description: 'Mystical spiritual style' }
//   ];
  
//   const handleGenerate = async () => {
//     if (!formData.title || !formData.theme) {
//       toast.error('Please enter both title and theme');
//       return;
//     }
    
//     setLoading(true);
//     try {
//       const response = await aiAPI.generatePoem(formData);
//       if (response.success) {
//         setGenerated(response.data);
//         toast.success(`Poem generated by ${response.data.provider}!`);
//       }
//     } catch (error) {
//       toast.error(error.response?.data?.message || 'Failed to generate poem');
//     } finally {
//       setLoading(false);
//     }
//   };
  
//   const handleCopy = (text) => {
//     navigator.clipboard.writeText(text);
//     setCopied(true);
//     toast.success('Copied to clipboard!');
//     setTimeout(() => setCopied(false), 2000);
//   };
  
//   const handleUse = () => {
//     if (generated && setFormData) {
//       setFormData(prev => ({
//         ...prev,
//         content: generated.content,
//         transliteration: generated.transliteration || '',
//         translation: generated.translation?.english || ''
//       }));
//       toast.success('AI generated content added to form!');
//       onClose();
//     }
//   };
  
//   return (
//     <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
//       <motion.div
//         initial={{ opacity: 0, scale: 0.95 }}
//         animate={{ opacity: 1, scale: 1 }}
//         className="bg-white rounded-xl max-w-2xl w-full max-h-[90vh] overflow-y-auto"
//       >
//         <div className="sticky top-0 bg-white border-b border-gray-200 px-6 py-4 flex items-center justify-between">
//           <div>
//             <h2 className="text-xl font-bold text-gray-900 flex items-center gap-2">
//               <Sparkles className="h-5 w-5 text-primary-600" />
//               AI Poem Generator
//             </h2>
//             <p className="text-sm text-gray-500 mt-1">Generate poetry with AI assistance</p>
//           </div>
//           <button onClick={onClose} className="p-2 rounded-lg hover:bg-gray-100">
//             <X className="h-5 w-5" />
//           </button>
//         </div>
        
//         <div className="p-6 space-y-4">
//           {/* Input Form */}
//           <div className="grid grid-cols-2 gap-4">
//             <div>
//               <label className="block text-sm font-medium text-gray-700 mb-1">Title *</label>
//               <input
//                 type="text"
//                 value={formData.title}
//                 onChange={(e) => setLocalFormData({ ...formData, title: e.target.value })}
//                 className="input-field"
//                 placeholder="Poem title"
//               />
//             </div>
//             <div>
//               <label className="block text-sm font-medium text-gray-700 mb-1">Genre</label>
//               <select
//                 value={formData.genre}
//                 onChange={(e) => setLocalFormData({ ...formData, genre: e.target.value })}
//                 className="input-field"
//               >
//                 {genres.map(g => (
//                   <option key={g.value} value={g.value}>{g.icon} {g.label}</option>
//                 ))}
//               </select>
//             </div>
//           </div>
          
//           <div>
//             <label className="block text-sm font-medium text-gray-700 mb-1">Theme/Mood *</label>
//             <input
//               type="text"
//               value={formData.theme}
//               onChange={(e) => setLocalFormData({ ...formData, theme: e.target.value })}
//               className="input-field"
//               placeholder="e.g., love, separation, nature, patriotism..."
//             />
//           </div>
          
//           <div className="grid grid-cols-2 gap-4">
//             <div>
//               <label className="block text-sm font-medium text-gray-700 mb-1">Language</label>
//               <select
//                 value={formData.language}
//                 onChange={(e) => setLocalFormData({ ...formData, language: e.target.value })}
//                 className="input-field"
//               >
//                 {languages.map(l => (
//                   <option key={l.value} value={l.value}>{l.script}</option>
//                 ))}
//               </select>
//             </div>
//             <div>
//               <label className="block text-sm font-medium text-gray-700 mb-1">Style</label>
//               <select
//                 value={formData.style}
//                 onChange={(e) => setLocalFormData({ ...formData, style: e.target.value })}
//                 className="input-field"
//               >
//                 {styles.map(s => (
//                   <option key={s.value} value={s.value}>{s.label}</option>
//                 ))}
//               </select>
//             </div>
//           </div>
          
//           <button
//             onClick={handleGenerate}
//             disabled={loading}
//             className="w-full btn-primary flex items-center justify-center gap-2 py-3"
//           >
//             {loading ? <Loader2 className="h-5 w-5 animate-spin" /> : <Wand2 className="h-5 w-5" />}
//             {loading ? 'Generating...' : 'Generate Poem with AI'}
//           </button>
          
//           {/* Generated Content */}
//           {generated && (
//             <motion.div
//               initial={{ opacity: 0, y: 20 }}
//               animate={{ opacity: 1, y: 0 }}
//               className="mt-4 space-y-4 border-t pt-4"
//             >
//               <div className="flex items-center justify-between">
//                 <h3 className="font-semibold text-gray-900">Generated Poem</h3>
//                 <div className="flex gap-2">
//                   <button
//                     onClick={() => handleCopy(generated.content)}
//                     className="p-1.5 rounded-lg hover:bg-gray-100"
//                   >
//                     {copied ? <Check className="h-4 w-4 text-green-600" /> : <Copy className="h-4 w-4" />}
//                   </button>
//                   <button
//                     onClick={handleUse}
//                     className="px-3 py-1.5 bg-green-600 text-white text-sm rounded-lg hover:bg-green-700 flex items-center gap-1"
//                   >
//                     <Plus className="h-3 w-3" />
//                     Use in Form
//                   </button>
//                 </div>
//               </div>
              
//               <div className="bg-gray-50 rounded-lg p-4">
//                 <pre className="whitespace-pre-wrap font-serif text-right urdu-text" dir="rtl">
//                   {generated.content}
//                 </pre>
//               </div>
              
//               {generated.transliteration && (
//                 <div>
//                   <h4 className="font-medium text-gray-700 mb-1">Transliteration</h4>
//                   <p className="text-gray-600 italic">{generated.transliteration}</p>
//                 </div>
//               )}
              
//               {generated.translation?.english && (
//                 <div>
//                   <h4 className="font-medium text-gray-700 mb-1">English Translation</h4>
//                   <p className="text-gray-600">{generated.translation.english}</p>
//                 </div>
//               )}
              
//               {generated.analysis && (
//                 <div className="bg-purple-50 rounded-lg p-3">
//                   <div className="flex items-center gap-1 text-purple-700 mb-2">
//                     <Sparkles className="h-4 w-4" />
//                     <span className="text-sm font-medium">AI Analysis</span>
//                   </div>
//                   <p className="text-sm text-gray-700">{generated.analysis.summary}</p>
//                   <div className="flex flex-wrap gap-2 mt-2">
//                     {generated.analysis.themes?.slice(0, 3).map((theme, i) => (
//                       <span key={i} className="text-xs bg-white px-2 py-1 rounded-full text-purple-600">
//                         {theme}
//                       </span>
//                     ))}
//                   </div>
//                 </div>
//               )}
              
//               <div className="text-xs text-gray-400 text-right">
//                 Generated by {generated.provider} • {generated.responseTime}ms
//               </div>
//             </motion.div>
//           )}
//         </div>
//       </motion.div>
//     </div>
//   );
// };

// export default AIGenerator;











// // client/src/components/ai/AIGenerator.jsx
// import React, { useState } from 'react';
// import { motion } from 'framer-motion';
// import { Sparkles, Loader2, Wand2, Copy, Check, Plus, X } from 'lucide-react';  // ← Add X here
// import toast from 'react-hot-toast';
// import aiAPI from '../../api/aiAPI';

// const AIGenerator = ({ onGenerated, onClose, existingFormData, setFormData }) => {
//   const [loading, setLoading] = useState(false);
//   const [generated, setGenerated] = useState(null);
//   const [copied, setCopied] = useState(false);
//   const [formData, setLocalFormData] = useState({
//     title: existingFormData?.title || '',
//     theme: '',
//     genre: existingFormData?.genre || 'ghazal',
//     language: 'urdu',
//     style: 'classical'
//   });
  
//   const genres = [
//     { value: 'ghazal', label: 'Ghazal', icon: '💕' },
//     { value: 'nazm', label: 'Nazm', icon: '📜' },
//     { value: 'sher', label: 'Sher', icon: '✨' },
//     { value: 'rubai', label: 'Rubai', icon: '🕌' }
//   ];
  
//   const languages = [
//     { value: 'urdu', label: 'Urdu', script: 'اردو' },
//     { value: 'hindi', label: 'Hindi', script: 'हिन्दी' },
//     { value: 'english', label: 'English', script: 'English' }
//   ];
  
//   const styles = [
//     { value: 'classical', label: 'Classical', description: 'Traditional classical style' },
//     { value: 'modern', label: 'Modern', description: 'Contemporary modern style' },
//     { value: 'romantic', label: 'Romantic', description: 'Love and romance focused' },
//     { value: 'sufi', label: 'Sufi', description: 'Mystical spiritual style' }
//   ];
  
//   const handleGenerate = async () => {
//     if (!formData.title || !formData.theme) {
//       toast.error('Please enter both title and theme');
//       return;
//     }
    
//     setLoading(true);
//     try {
//       const response = await aiAPI.generatePoem(formData);
//       if (response.success) {
//         setGenerated(response.data);
//         toast.success(`Poem generated by ${response.data.provider}!`);
//       }
//     } catch (error) {
//       toast.error(error.response?.data?.message || 'Failed to generate poem');
//     } finally {
//       setLoading(false);
//     }
//   };
  
//   const handleCopy = (text) => {
//     navigator.clipboard.writeText(text);
//     setCopied(true);
//     toast.success('Copied to clipboard!');
//     setTimeout(() => setCopied(false), 2000);
//   };
  
//   const handleUse = () => {
//     if (generated && setFormData) {
//       setFormData(prev => ({
//         ...prev,
//         content: generated.content,
//         transliteration: generated.transliteration || '',
//         translation: generated.translation?.english || ''
//       }));
//       toast.success('AI generated content added to form!');
//       onClose();
//     }
//   };
  
//   return (
//     <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
//       <motion.div
//         initial={{ opacity: 0, scale: 0.95 }}
//         animate={{ opacity: 1, scale: 1 }}
//         className="bg-white rounded-xl max-w-2xl w-full max-h-[90vh] overflow-y-auto"
//       >
//         <div className="sticky top-0 bg-white border-b border-gray-200 px-6 py-4 flex items-center justify-between">
//           <div>
//             <h2 className="text-xl font-bold text-gray-900 flex items-center gap-2">
//               <Sparkles className="h-5 w-5 text-primary-600" />
//               AI Poem Generator
//             </h2>
//             <p className="text-sm text-gray-500 mt-1">Generate poetry with AI assistance</p>
//           </div>
//           <button onClick={onClose} className="p-2 rounded-lg hover:bg-gray-100">
//             <X className="h-5 w-5" />
//           </button>
//         </div>
        
//         <div className="p-6 space-y-4">
//           {/* Input Form */}
//           <div className="grid grid-cols-2 gap-4">
//             <div>
//               <label className="block text-sm font-medium text-gray-700 mb-1">Title *</label>
//               <input
//                 type="text"
//                 value={formData.title}
//                 onChange={(e) => setLocalFormData({ ...formData, title: e.target.value })}
//                 className="input-field"
//                 placeholder="Poem title"
//               />
//             </div>
//             <div>
//               <label className="block text-sm font-medium text-gray-700 mb-1">Genre</label>
//               <select
//                 value={formData.genre}
//                 onChange={(e) => setLocalFormData({ ...formData, genre: e.target.value })}
//                 className="input-field"
//               >
//                 {genres.map(g => (
//                   <option key={g.value} value={g.value}>{g.icon} {g.label}</option>
//                 ))}
//               </select>
//             </div>
//           </div>
          
//           <div>
//             <label className="block text-sm font-medium text-gray-700 mb-1">Theme/Mood *</label>
//             <input
//               type="text"
//               value={formData.theme}
//               onChange={(e) => setLocalFormData({ ...formData, theme: e.target.value })}
//               className="input-field"
//               placeholder="e.g., love, separation, nature, patriotism..."
//             />
//           </div>
          
//           <div className="grid grid-cols-2 gap-4">
//             <div>
//               <label className="block text-sm font-medium text-gray-700 mb-1">Language</label>
//               <select
//                 value={formData.language}
//                 onChange={(e) => setLocalFormData({ ...formData, language: e.target.value })}
//                 className="input-field"
//               >
//                 {languages.map(l => (
//                   <option key={l.value} value={l.value}>{l.script}</option>
//                 ))}
//               </select>
//             </div>
//             <div>
//               <label className="block text-sm font-medium text-gray-700 mb-1">Style</label>
//               <select
//                 value={formData.style}
//                 onChange={(e) => setLocalFormData({ ...formData, style: e.target.value })}
//                 className="input-field"
//               >
//                 {styles.map(s => (
//                   <option key={s.value} value={s.value}>{s.label}</option>
//                 ))}
//               </select>
//             </div>
//           </div>
          
//           <button
//             onClick={handleGenerate}
//             disabled={loading}
//             className="w-full btn-primary flex items-center justify-center gap-2 py-3"
//           >
//             {loading ? <Loader2 className="h-5 w-5 animate-spin" /> : <Wand2 className="h-5 w-5" />}
//             {loading ? 'Generating...' : 'Generate Poem with AI'}
//           </button>
          
//           {/* Generated Content */}
//           {generated && (
//             <motion.div
//               initial={{ opacity: 0, y: 20 }}
//               animate={{ opacity: 1, y: 0 }}
//               className="mt-4 space-y-4 border-t pt-4"
//             >
//               <div className="flex items-center justify-between">
//                 <h3 className="font-semibold text-gray-900">Generated Poem</h3>
//                 <div className="flex gap-2">
//                   <button
//                     onClick={() => handleCopy(generated.content)}
//                     className="p-1.5 rounded-lg hover:bg-gray-100"
//                   >
//                     {copied ? <Check className="h-4 w-4 text-green-600" /> : <Copy className="h-4 w-4" />}
//                   </button>
//                   <button
//                     onClick={handleUse}
//                     className="px-3 py-1.5 bg-green-600 text-white text-sm rounded-lg hover:bg-green-700 flex items-center gap-1"
//                   >
//                     <Plus className="h-3 w-3" />
//                     Use in Form
//                   </button>
//                 </div>
//               </div>
              
//               <div className="bg-gray-50 rounded-lg p-4">
//                 <pre className="whitespace-pre-wrap font-serif text-right urdu-text" dir="rtl">
//                   {generated.content}
//                 </pre>
//               </div>
              
//               {generated.transliteration && (
//                 <div>
//                   <h4 className="font-medium text-gray-700 mb-1">Transliteration</h4>
//                   <p className="text-gray-600 italic">{generated.transliteration}</p>
//                 </div>
//               )}
              
//               {generated.translation?.english && (
//                 <div>
//                   <h4 className="font-medium text-gray-700 mb-1">English Translation</h4>
//                   <p className="text-gray-600">{generated.translation.english}</p>
//                 </div>
//               )}
              
//               {generated.analysis && (
//                 <div className="bg-purple-50 rounded-lg p-3">
//                   <div className="flex items-center gap-1 text-purple-700 mb-2">
//                     <Sparkles className="h-4 w-4" />
//                     <span className="text-sm font-medium">AI Analysis</span>
//                   </div>
//                   <p className="text-sm text-gray-700">{generated.analysis.summary}</p>
//                   <div className="flex flex-wrap gap-2 mt-2">
//                     {generated.analysis.themes?.slice(0, 3).map((theme, i) => (
//                       <span key={i} className="text-xs bg-white px-2 py-1 rounded-full text-purple-600">
//                         {theme}
//                       </span>
//                     ))}
//                   </div>
//                 </div>
//               )}
              
//               <div className="text-xs text-gray-400 text-right">
//                 Generated by {generated.provider} • {generated.responseTime}ms
//               </div>
//             </motion.div>
//           )}
//         </div>
//       </motion.div>
//     </div>
//   );
// };

// export default AIGenerator;











// client/src/components/ai/AIGenerator.jsx
import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Sparkles, Loader2, Wand2, Copy, Check, Plus, X } from 'lucide-react';
import toast from 'react-hot-toast';
import aiAPI from '../../api/aiAPI';

const AIGenerator = ({ onGenerated, onClose, existingFormData, setFormData }) => {
  const [loading, setLoading] = useState(false);
  const [generated, setGenerated] = useState(null);
  const [copied, setCopied] = useState(false);
  const [formData, setLocalFormData] = useState({
    title: existingFormData?.title || '',
    theme: '',
    genre: existingFormData?.genre || 'ghazal',
    language: 'urdu',
    style: 'classical'
  });
  
  const genres = [
    { value: 'ghazal', label: 'Ghazal', icon: '💕' },
    { value: 'nazm', label: 'Nazm', icon: '📜' },
    { value: 'sher', label: 'Sher', icon: '✨' },
    { value: 'rubai', label: 'Rubai', icon: '🕌' }
  ];
  
  const languages = [
    { value: 'urdu', label: 'Urdu', script: 'اردو' },
    { value: 'hindi', label: 'Hindi', script: 'हिन्दी' },
    { value: 'english', label: 'English', script: 'English' }
  ];
  
  const styles = [
    { value: 'classical', label: 'Classical', description: 'Traditional classical style' },
    { value: 'modern', label: 'Modern', description: 'Contemporary modern style' },
    { value: 'romantic', label: 'Romantic', description: 'Love and romance focused' },
    { value: 'sufi', label: 'Sufi', description: 'Mystical spiritual style' }
  ];
  
  const handleGenerate = async () => {
    if (!formData.title || !formData.theme) {
      toast.error('Please enter both title and theme');
      return;
    }
    
    setLoading(true);
    try {
      const response = await aiAPI.generatePoem(formData);
      if (response.success) {
        setGenerated(response.data);
        toast.success(`Poem generated by ${response.data.provider}!`);
      } else {
        toast.error(response.message || 'Failed to generate poem');
      }
    } catch (error) {
      console.error('Generation error:', error);
      toast.error(error.response?.data?.message || 'Failed to generate poem');
    } finally {
      setLoading(false);
    }
  };
  
  const handleCopy = (text) => {
    navigator.clipboard.writeText(text);
    setCopied(true);
    toast.success('Copied to clipboard!');
    setTimeout(() => setCopied(false), 2000);
  };
  
  // ============================================
  // FIXED: Auto-populate form fields when "Use in Form" is clicked
  // ============================================
  const handleUseInForm = () => {
    if (generated && setFormData) {
      // Populate all form fields
      setFormData(prev => ({
        ...prev,
        title: formData.title,  // Use the title from generator
        content: generated.content,  // Poem content
        transliteration: generated.transliteration || '',
        translation: generated.translation?.english || '',
        genre: formData.genre,
        language: formData.language,
        isPublished: false  // Default to draft, user can publish later
      }));
      
      toast.success('AI generated content added to form!');
      
      // Call onGenerated callback if provided
      if (onGenerated) {
        onGenerated(generated);
      }
      
      // Close the modal
      onClose();
    }
  };
  
  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <motion.div
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
        className="bg-white rounded-xl max-w-2xl w-full max-h-[90vh] overflow-y-auto"
      >
        <div className="sticky top-0 bg-white border-b border-gray-200 px-6 py-4 flex items-center justify-between">
          <div>
            <h2 className="text-xl font-bold text-gray-900 flex items-center gap-2">
              <Sparkles className="h-5 w-5 text-primary-600" />
              AI Poem Generator
            </h2>
            <p className="text-sm text-gray-500 mt-1">Generate poetry with AI assistance</p>
          </div>
          <button onClick={onClose} className="p-2 rounded-lg hover:bg-gray-100">
            <X className="h-5 w-5" />
          </button>
        </div>
        
        <div className="p-6 space-y-4">
          {/* Input Form */}
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Title *</label>
              <input
                type="text"
                value={formData.title}
                onChange={(e) => setLocalFormData({ ...formData, title: e.target.value })}
                className="input-field"
                placeholder="Poem title"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Genre</label>
              <select
                value={formData.genre}
                onChange={(e) => setLocalFormData({ ...formData, genre: e.target.value })}
                className="input-field"
              >
                {genres.map(g => (
                  <option key={g.value} value={g.value}>{g.icon} {g.label}</option>
                ))}
              </select>
            </div>
          </div>
          
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Theme/Mood *</label>
            <input
              type="text"
              value={formData.theme}
              onChange={(e) => setLocalFormData({ ...formData, theme: e.target.value })}
              className="input-field"
              placeholder="e.g., love, separation, nature, patriotism, Karbala..."
            />
          </div>
          
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Language</label>
              <select
                value={formData.language}
                onChange={(e) => setLocalFormData({ ...formData, language: e.target.value })}
                className="input-field"
              >
                {languages.map(l => (
                  <option key={l.value} value={l.value}>{l.script}</option>
                ))}
              </select>
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Style</label>
              <select
                value={formData.style}
                onChange={(e) => setLocalFormData({ ...formData, style: e.target.value })}
                className="input-field"
              >
                {styles.map(s => (
                  <option key={s.value} value={s.value}>{s.label}</option>
                ))}
              </select>
            </div>
          </div>
          
          <button
            onClick={handleGenerate}
            disabled={loading}
            className="w-full btn-primary flex items-center justify-center gap-2 py-3"
          >
            {loading ? <Loader2 className="h-5 w-5 animate-spin" /> : <Wand2 className="h-5 w-5" />}
            {loading ? 'Generating...' : 'Generate Poem with AI'}
          </button>
          
          {/* Generated Content */}
          {generated && (
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              className="mt-4 space-y-4 border-t pt-4"
            >
              <div className="flex items-center justify-between">
                <h3 className="font-semibold text-gray-900">Generated Poem</h3>
                <div className="flex gap-2">
                  <button
                    onClick={() => handleCopy(generated.content)}
                    className="p-1.5 rounded-lg hover:bg-gray-100"
                    title="Copy to clipboard"
                  >
                    {copied ? <Check className="h-4 w-4 text-green-600" /> : <Copy className="h-4 w-4" />}
                  </button>
                  <button
                    onClick={handleUseInForm}
                    className="px-3 py-1.5 bg-green-600 text-white text-sm rounded-lg hover:bg-green-700 flex items-center gap-1"
                    title="Add to poem form"
                  >
                    <Plus className="h-3 w-3" />
                    Use in Form
                  </button>
                </div>
              </div>
              
              {/* Poem Content Display */}
              <div className="bg-gray-50 rounded-lg p-4 max-h-64 overflow-y-auto">
                <pre className="whitespace-pre-wrap font-serif text-right urdu-text" dir="rtl">
                  {generated.content}
                </pre>
              </div>
              
              {/* Transliteration */}
              {generated.transliteration && (
                <div>
                  <h4 className="font-medium text-gray-700 mb-1">Transliteration</h4>
                  <p className="text-gray-600 italic">{generated.transliteration}</p>
                </div>
              )}
              
              {/* English Translation */}
              {generated.translation?.english && (
                <div>
                  <h4 className="font-medium text-gray-700 mb-1">English Translation</h4>
                  <p className="text-gray-600">{generated.translation.english}</p>
                </div>
              )}
              
              {/* AI Analysis Preview */}
              {generated.analysis && (
                <div className="bg-purple-50 rounded-lg p-3">
                  <div className="flex items-center gap-1 text-purple-700 mb-2">
                    <Sparkles className="h-4 w-4" />
                    <span className="text-sm font-medium">AI Analysis Preview</span>
                  </div>
                  <p className="text-sm text-gray-700">{generated.analysis.summary || generated.analysis.meaning}</p>
                  <div className="flex flex-wrap gap-2 mt-2">
                    {generated.analysis.themes?.slice(0, 3).map((theme, i) => (
                      <span key={i} className="text-xs bg-white px-2 py-1 rounded-full text-purple-600">
                        {theme}
                      </span>
                    ))}
                  </div>
                </div>
              )}
              
              {/* Provider Info */}
              <div className="text-xs text-gray-400 text-right">
                Generated by {generated.provider} • {generated.responseTime}ms
              </div>
            </motion.div>
          )}
        </div>
      </motion.div>
    </div>
  );
};

export default AIGenerator;